import styled from '@emotion/styled';
import { H2, H3 } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  alignItems: 'center',
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    flexDirection: 'column',
  },
}));

export const ValueText = styled.div<{ isBold: boolean }>(({ theme, isBold }) => ({
  fontSize: `${typographyFontSizeCfg.h2.mobile}px`,
  lineHeight: `${typographyLineHeightCfg.h2.mobile}px`,
  color: theme.colors.neutrals.grey1,
  fontWeight: isBold ? 700 : 400,
}));

export const BackDivider = styled.div(({ theme }) => ({
  width: '1px',
  height: '20px',
  backgroundColor: theme.colors.neutrals.grey6,
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    display: 'none',
  },
}));

export const MobileValueText = styled(H2.withComponent('div'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const DescriptionText = styled(H3.withComponent('div'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;
